export enum ENDPOINTS {
  COUNTRY_MASKS = '/internationalization/v1/masks',
}
